import React from "react";

export default function About() {
    return (
        <div className="about">
            <h4 className="header">About</h4>
            <p className="content">I am a software developer, currently working
                as a microservices backend developer. I am
                really interested in all things web and want to improve on
                becoming a full stack developer one day.
            </p>
        </div>
    )
}